import { AnaliseDescontoStatus } from './enum';

export class AnaliseDesconto {
  id: number;
  idCupom: string;
  dtCriacao: Date;
  status: AnaliseDescontoStatus;
  statusDescricao: string;
  dtStatus: Date;
  valorDoPedido: number;
  valorSolicitado: number;
  valorAutorizado: number;
  descontoAutorizado: number;
  idTarefa: number;
  tipoDesconto: number;
  descontoValido: boolean;
  percentualAutorizado: number;
  tipoSolicitante: number;
  idSolicitante: number;
  nomeSolicitante: string;
  ultimaObs: string;
  cmv: number;
  idFormaPag: number;
  formaPagamento: string;
  tipoFrete: number;
}
